import React, {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {
    AppBar,
    Card,
    CardContent,
    Toolbar,
    Typography
} from '@material-ui/core'
import {withRouter} from "react-router-dom"
import ReduxMedical from "../../../../../store/actionreducers/adminMedical/medical"
import * as _ from 'lodash'
import moment from "moment"

const BasicInfoTab = ({medical: _medical}) => {
    const [medical, setMedical] = useState({
        user: {
            birthday: '',
            cell_phone_no: '',
            email: '',
            role: {
                label: '',
            },
            sex: '',
        },
    })

    useEffect(() => {
        if (!_.isEqual(medical, _medical))
            setMedical(_medical)
    }, [_medical])

    return (
        <div>
            <Card className="w-full mb-16">
                <AppBar position="static" elevation={0}>
                    <Toolbar className="pl-16 pr-8">
                        <Typography variant="subheading" color="inherit" className="flex-1">
                            個人資料
                        </Typography>
                    </Toolbar>
                </AppBar>

                <CardContent>
                    <div className="mb-24">
                        <Typography className="font-bold mb-4 text-15">信箱</Typography>
                        {medical.user.email}
                    </div>
                    <div className="mb-24">
                        <Typography className="font-bold mb-4 text-15">性別</Typography>
                        {medical.user.sex}
                    </div>
                    <div className="mb-24">
                        <Typography className="font-bold mb-4 text-15">手機號碼</Typography>
                        {
                            medical.user.cell_phone_no
                            ||`${medical.user.phone_country_code} ${medical.user.phone_number}`
                        }
                        <Typography className="mt-4 text-15" style={{color: '#005AB5'}}>
                            {medical.user.sms_verified_at ?
                                `驗證日期: ${moment(medical.user.sms_verified_at).format('YYYY-MM-DD')}`
                                : '尚未驗證手機號碼'}
                        </Typography>
                    </div>
                    <div className="mb-24">
                        <Typography className="font-bold mb-4 text-15">所屬醫療機構</Typography>
                        {medical.hospital && medical.hospital.name}
                    </div>
                </CardContent>
            </Card>
        </div>
    )
}


function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMedical: ReduxMedical.ActionCreator.getMedical,
    }, dispatch)
}


function mapStateToProps({adminMedicalList: {medical}}) {
    return {
        medical
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BasicInfoTab))



// WEBPACK FOOTER //
// ./src/main/content/adminMedical/institutionMedical/tabs/BasicInfoTab.js